import React, { useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { getImageUrl, generateSlug, devitems } from './../Common/Helpers';

/* const projects = [
    {
        image: require('./../../images/projects/square/pic4.jpg'),
        title: 'Life style building',
        description: 'Engineering your dreams with us the architect has always.'
    },
    {
        image: require('./../../images/projects/square/pic9.jpg'),
        title: 'Modern Bathroom',
        description: 'Engineering your dreams with us the architect has always.'
    },
    {
        image: require('./../../images/projects/square/pic10.jpg'),
        title: 'Dream House',
        description: 'Engineering your dreams with us the architect has always.'
    },
    {
        image: require('./../../images/projects/square/pic6.jpg'),
        title: 'Bellevue Projects',
        description: 'Engineering your dreams with us the architect has always.'
    },
    {
        image: require('./../../images/projects/square/pic7.jpg'),
        title: 'Modish Interior',
        description: 'Engineering your dreams with us the architect has always.'
    },
    {
        image: require('./../../images/projects/square/pic8.jpg'),
        title: 'Vilters',
        description: 'Engineering your dreams with us the architect has always.'
    },
    {
        image: require('./../../images/projects/square/pic9.jpg'),
        title: 'Dream Home',
        description: 'Engineering your dreams with us the architect has always.'
    },
    {
        image: require('./../../images/projects/square/pic2.jpg'),
        title: 'Living Room',
        description: 'Engineering your dreams with us the architect has always.'
    }
] */

var bgimg1 = require('./../../images/background/cross-line2.png');

class Projects7 extends React.Component {

    /**
     * Lógica para filtrar y cortar el array devitems.
     * @returns {Array} Un array que contiene un máximo de 10 elementos a partir de startId.
     */
    getSlicedItems() {
        const { startId } = this.props;

        if (!devitems || devitems.length === 0 || !startId) {
            return [];
        }

        // 1. Encontrar el índice del elemento donde comienza el ID
        // Usamos Number() para asegurar la comparación correcta de IDs.
        const startIndex = devitems.findIndex(item =>
            Number(item.id) === Number(startId)
        );

        // Si el ID de inicio no se encuentra, o está fuera del límite.
        if (startIndex === -1 || startIndex >= devitems.length) {
            return [];
        }

        // 2. Cortar el array: obtenemos 10 elementos a partir del startIndex
        // .slice(inicio, fin)
        return devitems.slice(startIndex, startIndex + 10);
    }

    render() {
        const options = {
            loop: true,
            autoplay: false,
            center: false,
            items: 3,
            margin: 40,
            nav: true,
            dots: false,
            navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
            responsive: {
                0: {
                    items: 1,
                    margin: 15,
                },
                640: {
                    items: 2,
                    margin: 15
                },
                768: {
                    items: 2,
                    margin: 15
                },
                991: {
                    items: 3,
                    margin: 15
                },
                1200: {
                    items: 3
                }

            }
        };

        // Obtenemos el array cortado y limitado de 10 elementos
        const slicedItems = this.getSlicedItems();

        if (slicedItems.length === 0) {
            return <p>No se encontraron fichas válidos para el ID de inicio.</p>;
        }

        return (
            <>
                <div className="section-full p-tb80 bg-gray inner-page-padding">
                    <div className="container-fluid">
                        <div className="section-content">
                            {/* TITLE START */}
                            <div className="section-head">
                                <div className="sx-separator-outer separator-left">
                                    <div className="sx-separator bg-white bg-moving bg-repeat-x" style={{ backgroundImage: 'url(' + bgimg1 + ')' }}>
                                        <h3 className="sep-line-one">Ver más fichas</h3>
                                    </div>
                                </div>
                            </div>
                            {/* TITLE END */}
                            <div className="work-carousel-outer">
                                <OwlCarousel className="owl-carousel mfp-gallery project-carousel project-carousel3 owl-btn-vertical-center p-lr80" {...options}>
                                    {slicedItems.map((item, index) => {
                                        const itemSlug = generateSlug(item.id, item.Nombre);
                                        return (<div key={index} className="item">
                                            <div className="project-mas m-a30">
                                                <div className="image-effect-one">
                                                    <NavLink to={`/ficha/${itemSlug}`} state={{ projectData: item }} >
                                                        <img src={getImageUrl(item.id + "pearch.jpg", item.SEXO)} alt="" />
                                                    </NavLink>
                                                    {/* 
                                                    <a className="mfp-link" href={getImageUrl(item.id + "pearch.jpg")}>
                                                        
                                                    </a>                                                      <div className="figcaption">
                    <i className="fa fa-arrows-alt" />
                                                    </div>  */}
                                                </div>
                                                <div className="project-info p-a20 bg-white">
                                                    <h4 className="sx-tilte m-t0"><NavLink to={`/ficha/${itemSlug}`} state={{ projectData: item }} >{item.Nombre}</NavLink></h4>
                                                    <p>{item.description}</p>
                                                    <NavLink to={"#"}><i className="link-plus bg-primary" /></NavLink>
                                                </div>
                                            </div>
                                        </div>);

                                    })}
                                </OwlCarousel>
                            </div>
                        </div>
                    </div>
                </div>

            </>
        );
    }
};

export default Projects7;